import { Box, Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AdminHeader: React.FC = () => {
  const navigate = useNavigate();
  const handleBackToSite = () => {
    navigate('/');
  };

  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        backgroundColor: '#333',
        position: 'sticky',
        top: 0,
        width: '100%',
        minHeight: '75px',
      }}
    >
      <Box
        style={{
          // add padding to the box
          padding: '10px',
        }}
      >
        <Button
          style={{
            // add margin to the button
            margin: '10px',
            // make the button white
            color: 'white',
            // make the button look clickable
            cursor: 'pointer',
            // add a silver border to the button with rounded edges
            border: '1px solid silver',
            padding: '5px 10px',
            // move the button away from the edge of the page
            marginRight: '10px',
          }}
          onClick={handleBackToSite}
        >
          Back to Site
        </Button>
      </Box>
    </Box>
  );
};

export default AdminHeader;
